import { inject } from "@angular/core";
import type { CanActivateFn } from "@angular/router";
import { Router } from "@angular/router";
import { AuthService } from "@magpie/services";

/**
 * Auth guard - protects routes that require authentication.
 * Redirects to /auth if user is not authenticated.
 */
export const authGuard: CanActivateFn = () => {
	const authService = inject(AuthService);
	const router = inject(Router);

	if (authService.isAuthenticated()) {
		return true;
	}

	// Redirect to auth page if not authenticated
	return router.createUrlTree(["/auth"]);
};

/**
 * Public guard - protects routes that should only be accessible to non-authenticated users.
 * Redirects to /home if user is already authenticated.
 */
export const publicGuard: CanActivateFn = () => {
	const authService = inject(AuthService);
	const router = inject(Router);

	if (!authService.isAuthenticated()) {
		return true;
	}

	// Redirect to home if already authenticated
	return router.createUrlTree(["/home"]);
};
